import React from 'react';

import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { ChakraFlex, ChakraSwitch, ChakraText } from '@equip.health/ui';
import { isEmpty } from 'lodash';

import { TABLE_DEFAULT_COLUMNS } from '~/lib/constants/patients.constants';

const TOP_LEVEL_ID = 'patient-column-item';

type PatientColumnItemProps = {
  filterState: string[];
  keyId: string;
  listeners?: SyntheticListenerMap;
  onSwitchChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string,
  ) => void;
  text: string;
};

const PatientColumnItem = ({
  filterState,
  keyId,
  listeners = {},
  onSwitchChange,
  text,
}: PatientColumnItemProps) => {
  return (
    <ChakraFlex
      marginY="10px"
      overflowY="visible"
      paddingLeft="4px"
      position="relative"
    >
      <ChakraSwitch
        colorScheme="teal"
        id={`${TOP_LEVEL_ID}__${keyId}__switch`}
        isChecked={(filterState ?? []).includes(keyId)}
        isDisabled={TABLE_DEFAULT_COLUMNS.includes(keyId)}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          onSwitchChange(event, keyId);
        }}
      />
      <ChakraText
        _active={{ cursor: 'grabbing' }}
        cursor={isEmpty(listeners) ? 'pointer' : 'grab'}
        fontSize="14px"
        id={`${TOP_LEVEL_ID}__${keyId}__text`}
        lineHeight="17px"
        marginLeft="8px"
        {...listeners}
      >
        {text}
      </ChakraText>
    </ChakraFlex>
  );
};

export default PatientColumnItem;
